import { gql } from '@apollo/client/core'

import {
  SERVER_ERROR,
  UNAUTHENTICATED_ERROR,
  UNAUTHORIZED_ERROR
} from '@base/api/fragments/errors'

import { EVENT_FRAGMENT } from '../fragments/event'
import { ATTRIBUTE_FRAGMENT } from '@base/api/fragments/attribute'

export const GET_EVENT_QUERY = gql`
  ${SERVER_ERROR}
  ${UNAUTHENTICATED_ERROR}
  ${UNAUTHORIZED_ERROR}
  ${EVENT_FRAGMENT}
  ${ATTRIBUTE_FRAGMENT}

  query getEvent($slug: String) {
    getEvent(slug: $slug, includeDraft: false, includeDeactivated: false, includeArchived: false) {
      ... on GetEventOutput {
        event {
          ...Event
        }
      }
      ...ServerError
      ...UnauthorizedError
      ...UnauthenticatedError
    }
  }
`
